import { TagBuilder } from './tag-builder';

export class FacetTagBuilder extends TagBuilder {
  public readonly value: string = '';

  constructor(value: string = '') {
    super();
    this.value = value;
  }

  public build(): string {
    const tag: string = this.getFacetTag();
    return super.build(tag);
  }

  private getFacetTag() {
    return this.value || '';
  }
}
